var map = {
	"./100-mil-book-aus.svg": 201,
	"./100-mil-book-es.svg": 202,
	"./100-mil-book.svg": 203,
	"./3000-outlets-aus.svg": 204,
	"./3000-outlets-es.svg": 205,
	"./3000-outlets.svg": 206,
	"./50-countries-aus.svg": 207,
	"./50-countries-es.svg": 208,
	"./50-countries.svg": 209,
	"./70-mil-authors-aus.svg": 210,
	"./70-mil-authors-es.svg": 211,
	"./70-mil-authors.svg": 212,
	"./Componente 6 – 2.svg": 213,
	"./Componente 7 – 2.svg": 214,
	"./Componente 8 – 2.svg": 215,
	"./Google_Play.svg": 216,
	"./Logo_ESP_BRANCO.png": 217,
	"./Logo_ESP_ROXO.png": 218,
	"./a4-white.svg": 219,
	"./a4.svg": 220,
	"./a5-white.svg": 221,
	"./a5.svg": 222,
	"./after-01.png": 223,
	"./after-02.png": 224,
	"./after-03.png": 225,
	"./agbook-logo-editor-load.jpg": 226,
	"./agbook-logo-mobile-2.jpg": 227,
	"./agbook-logo-mobile.png": 134,
	"./agbook-logo.png": 228,
	"./ajustes2.png": 229,
	"./alphagraphics.svg": 230,
	"./amex.svg": 231,
	"./arquivo2.png": 232,
	"./authorfreely_primarylogo.png": 122,
	"./avaliacao2.png": 233,
	"./background-service-all.png": 234,
	"./background-stores.jpg": 235,
	"./banner_partner_stores.png": 236,
	"./bb.svg": 237,
	"./blogger-round-svgrepo-com.svg": 238,
	"./boleto.svg": 239,
	"./book-1-translation.png": 240,
	"./book-1.png": 241,
	"./book-2.png": 242,
	"./book-3.png": 243,
	"./book-old.png": 244,
	"./book-type-orange.svg": 245,
	"./book-type-red.svg": 246,
	"./book-type.png": 247,
	"./book-type.svg": 248,
	"./book-upload-icon.svg": 249,
	"./book.png": 250,
	"./bottom-background.png": 251,
	"./bradesco.svg": 252,
	"./brand-tiktok-svgrepo-com.svg": 253,
	"./card-icon-1.svg": 254,
	"./card-icon-2.svg": 255,
	"./card-icon-3.svg": 256,
	"./card-icon-4.svg": 257,
	"./card.svg": 258,
	"./chevron-right-black.svg": 259,
	"./chevron-right.svg": 260,
	"./close.svg": 261,
	"./clube-icon-decorator.png": 262,
	"./completed-purchase-book-aus.png": 263,
	"./completed-purchase-book.png": 264,
	"./congratulations-aus.png": 265,
	"./correcoes2.png": 266,
	"./cover-revision.png": 267,
	"./creditcard.png": 268,
	"./cta-desktop-en.png": 269,
	"./cta-desktop-red.png": 270,
	"./cta-desktop.png": 271,
	"./cta-desktop_es.jpg": 272,
	"./cta-mobile-en.png": 273,
	"./cta-mobile-red.png": 274,
	"./cta-mobile.png": 275,
	"./cta-mobile_es.jpg": 276,
	"./diners.svg": 277,
	"./divulgacao2.png": 278,
	"./esboco.png": 279,
	"./esboco.svg": 280,
	"./facebook-share-pink.svg": 281,
	"./facebook.svg": 282,
	"./first-circle.svg": 283,
	"./frete-gratis.png": 284,
	"./hand-intelligent.png": 285,
	"./happy-man-using-his-tablet-home-couch_1.png": 286,
	"./happy-man-using-his-tablet-home-couch_2.png": 287,
	"./happy-man-using-his-tablet-home-couch_3.png": 288,
	"./happy-man-using-his-tablet-home-couch_4.png": 289,
	"./hero-background-mobile.png": 290,
	"./hero-background.png": 291,
	"./hero-book-image.png": 292,
	"./hipercard.svg": 293,
	"./icon-a4.svg": 294,
	"./icon-a5.svg": 295,
	"./icon-add.svg": 296,
	"./icon-amazon.svg": 297,
	"./icon-americanas.svg": 298,
	"./icon-apple.svg": 299,
	"./icon-arrow-down-grey.svg": 300,
	"./icon-arrow-down-purple-orange.svg": 301,
	"./icon-arrow-down-purple-white.svg": 302,
	"./icon-arrow-down-purple.svg": 303,
	"./icon-arrow-left-pagination.svg": 304,
	"./icon-arrow-right-orange.svg": 305,
	"./icon-arrow-right-pagination.svg": 306,
	"./icon-arrow-right-pink.svg": 307,
	"./icon-arrow-right-white.svg": 308,
	"./icon-book-grey.svg": 309,
	"./icon-book-orange.svg": 310,
	"./icon-book-purple.svg": 311,
	"./icon-book-white.svg": 312,
	"./icon-burger-purple.svg": 313,
	"./icon-burger-white.svg": 314,
	"./icon-camera.svg": 315,
	"./icon-cart-grey.svg": 316,
	"./icon-cart-white.svg": 317,
	"./icon-chat-orange.svg": 318,
	"./icon-chat-red.svg": 319,
	"./icon-chat.svg": 320,
	"./icon-check-green.svg": 321,
	"./icon-check-pink.svg": 322,
	"./icon-check-red.svg": 323,
	"./icon-check-white.svg": 324,
	"./icon-chevron_left-orange.svg": 325,
	"./icon-chevron_left-red.svg": 326,
	"./icon-chevron_left.svg": 327,
	"./icon-chevron_right.svg": 328,
	"./icon-close-quote.svg": 329,
	"./icon-cross-purple.svg": 330,
	"./icon-cross-red.svg": 331,
	"./icon-cross-white.svg": 332,
	"./icon-donthave.svg": 333,
	"./icon-download.svg": 334,
	"./icon-ebook-orange.svg": 335,
	"./icon-ebook.svg": 336,
	"./icon-epub.svg": 337,
	"./icon-estantevirtual.svg": 338,
	"./icon-exit-aila-editor.svg": 339,
	"./icon-export.svg": 340,
	"./icon-external.svg": 341,
	"./icon-facebook-purple.svg": 342,
	"./icon-feature-detail.svg": 343,
	"./icon-full-cover.svg": 344,
	"./icon-globe.png": 345,
	"./icon-googleplay.svg": 346,
	"./icon-has.svg": 347,
	"./icon-hasnt.svg": 348,
	"./icon-have.svg": 349,
	"./icon-header-aila-editor.svg": 350,
	"./icon-image-gallery.svg": 351,
	"./icon-image-upload.svg": 352,
	"./icon-livrariacultura.svg": 353,
	"./icon-logo-blog-white.svg": 354,
	"./icon-lp-1-orange.svg": 355,
	"./icon-lp-1-red.svg": 356,
	"./icon-lp-1.svg": 357,
	"./icon-lp-2-orange.svg": 358,
	"./icon-lp-2-red.svg": 359,
	"./icon-lp-2.svg": 360,
	"./icon-lp-3-red.svg": 361,
	"./icon-lp-3.svg": 362,
	"./icon-mercadolivre.svg": 363,
	"./icon-mini-book-orange.svg": 364,
	"./icon-mini-book.svg": 365,
	"./icon-money-orange.svg": 366,
	"./icon-money-purple.svg": 367,
	"./icon-open-chart-orange.svg": 368,
	"./icon-open-chart.svg": 369,
	"./icon-open-quote.svg": 370,
	"./icon-person-grey.svg": 371,
	"./icon-person-white.svg": 372,
	"./icon-play-two.svg": 373,
	"./icon-play.svg": 374,
	"./icon-pocket.svg": 375,
	"./icon-print-orange.svg": 376,
	"./icon-print.svg": 377,
	"./icon-profile-orange.svg": 378,
	"./icon-profile-red.svg": 379,
	"./icon-profile.svg": 380,
	"./icon-quadrado.svg": 381,
	"./icon-questionmark-orange.svg": 382,
	"./icon-questionmark-red.svg": 383,
	"./icon-questionmark.svg": 384,
	"./icon-rakuten.svg": 385,
	"./icon-search-purple-orange.svg": 386,
	"./icon-search-purple.svg": 387,
	"./icon-select-arrow.svg": 388,
	"./icon-separated-cover.svg": 389,
	"./icon-seu-livro-red.png": 390,
	"./icon-seu-livro.png": 391,
	"./icon-speak-orange.svg": 392,
	"./icon-speak-purple.svg": 393,
	"./icon-submarino.svg": 394,
	"./icon-trash-can.svg": 395,
	"./icon-trash.svg": 396,
	"./icon-tu-libro.png": 397,
	"./icon-twitter-purple.svg": 398,
	"./icon-upload-white.svg": 399,
	"./icon-upload.svg": 400,
	"./icon_linkedin.svg": 401,
	"./icons8-check.gif": 402,
	"./idioma-33.png": 403,
	"./img-footer-es.svg": 404,
	"./img-footer.svg": 405,
	"./img2-footer-aus.svg": 406,
	"./img2-footer-es.svg": 407,
	"./img2-footer.svg": 408,
	"./info-orange.svg": 409,
	"./info-pink.svg": 410,
	"./info-red.svg": 411,
	"./info.svg": 412,
	"./info1.jpg": 413,
	"./info2.jpg": 414,
	"./info3.jpg": 415,
	"./instagram-share-pink.svg": 416,
	"./instagram.svg": 417,
	"./itau.svg": 418,
	"./laptop-cda.png": 419,
	"./linkedin.svg": 420,
	"./lock.svg": 421,
	"./logo-amazon-color.png": 422,
	"./logo-amazon.png": 423,
	"./logo-americanas-color.png": 424,
	"./logo-americanas.png": 425,
	"./logo-apple-color.png": 426,
	"./logo-apple.png": 427,
	"./logo-authorfreely-mobile.png": 123,
	"./logo-cda-mobile.svg": 428,
	"./logo-cda.svg": 429,
	"./logo-club-de-autores.png": 430,
	"./logo-clube-de-autores-share.png": 431,
	"./logo-clube-de-autores-share.svg": 432,
	"./logo-clube-de-autores.svg": 433,
	"./logo-cultura-color.png": 434,
	"./logo-cultura.png": 435,
	"./logo-estante-color.png": 436,
	"./logo-estante.png": 437,
	"./logo-google-color.png": 438,
	"./logo-google.png": 439,
	"./logo-mercado-color.png": 440,
	"./logo-mercado.png": 441,
	"./logo-rakuten-color.png": 442,
	"./logo-rakuten.png": 443,
	"./logo-submarino-color.png": 444,
	"./logo-submarino.png": 445,
	"./lp-banner-a-desktop.png": 446,
	"./lp-banner-a-mobile.png": 447,
	"./lp-banner-b-desktop-red.png": 448,
	"./lp-banner-b-desktop.png": 449,
	"./lp-banner-b-mobile-red.png": 450,
	"./lp-banner-b-mobile.png": 451,
	"./mastercard.svg": 452,
	"./medium-shot-excited-woman-with-laptop-2.png": 453,
	"./medium-shot-excited-woman-with-laptop-mini-1.png": 454,
	"./medium-shot-excited-woman-with-laptop-mini-2.png": 455,
	"./medium-shot-excited-woman-with-laptop-mini-3.png": 456,
	"./medium-shot-excited-woman-with-laptop.png": 457,
	"./new-icon-facebook.svg": 458,
	"./new-icon-linkedin.svg": 459,
	"./new-icon-twitter.svg": 460,
	"./norton.svg": 461,
	"./nota-final2.png": 462,
	"./pix.png": 463,
	"./pocket-white.svg": 464,
	"./pocket.svg": 465,
	"./preco2.png": 466,
	"./privacidade2.png": 467,
	"./publico2.png": 468,
	"./publish-book.png": 469,
	"./publish-book_agbook-2.png": 470,
	"./publish-book_agbook.png": 471,
	"./publish-book_en.png": 472,
	"./publish-book_es.png": 473,
	"./quadrado-white.svg": 474,
	"./quadrado.svg": 475,
	"./relatorio2.png": 476,
	"./responsabilidade.png": 477,
	"./room-circle.svg": 478,
	"./second-circle.svg": 479,
	"./slider-arrow-left-grey.svg": 480,
	"./slider-arrow-right-grey.svg": 481,
	"./stars_1-orange.svg": 482,
	"./stars_1-red.svg": 483,
	"./stars_1.svg": 484,
	"./stars_2-orange.svg": 485,
	"./stars_2-red.svg": 486,
	"./stars_2.svg": 487,
	"./stars_3-orange.svg": 488,
	"./stars_3-red.svg": 489,
	"./stars_3.svg": 490,
	"./stars_4-orange.svg": 491,
	"./stars_4-red.svg": 492,
	"./stars_4.svg": 493,
	"./stars_5-orange.svg": 494,
	"./stars_5-red.svg": 495,
	"./stars_5.svg": 496,
	"./stars_sprint.png": 497,
	"./stars_sprint.svg": 498,
	"./stars_sprint_orange.svg": 499,
	"./stars_sprint_red.svg": 500,
	"./third-circle.svg": 501,
	"./twitter-share-pink.svg": 502,
	"./twitter.svg": 503,
	"./user-account-en.png": 504,
	"./user-book.png": 505,
	"./visa.svg": 506,
	"./whatsapp.svg": 507,
	"./word-file-icon.svg": 508,
	"./word-message-aus.svg": 509,
	"./word-message-es.svg": 510,
	"./word-message.svg": 511,
	"./wordpress.svg": 512,
	"./your-book-mini-aus.png": 513,
	"./youtube-play-svgrepo-com.svg": 514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 200;